import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGame = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 16,
			width: 32,
			height: 18,
			rx: 9,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 22v6M15 25h6",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 31,
			cy: 23,
			r: 1.5,
			fill: "currentColor",
			opacity: .5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 35,
			cy: 27,
			r: 1.5,
			fill: "currentColor",
			opacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 16l4-6 4 6",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeLinecap: "round",
			opacity: .25
		})
	]
});
export default SvgGame;
